import React from 'react'
import { Switch, Route } from 'react-router'
import { ToastContainer } from 'react-toastify'

import 'bootstrap/dist/css/bootstrap.min.css'
import './layouts/html/assets/css/style.css'
import EmailVerification from '@features/email-verification'
// Layouts
import {
  MainLayout
} from './layouts'

type Props = {}

const App: React.FC<Props> = () => (
  <>
    <Switch>
      <Route path="/email-verification" component={EmailVerification} />
      <Route path="/" component={MainLayout} />
    </Switch>
    <ToastContainer position="bottom-right" />
  </>
)

export default App
